import SEO from "./seo.json";

export default SEO;
